import(/* webpackMode: "eager" */ "/codebuild/output/src3121327455/src/salesdashboard/src/app/page.tsx");
